/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import DataTable from '../Common/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { cleanInstitutions, getInstitutions } from '../../store/actions';
import { Button } from 'reactstrap';
import { useToasts } from 'react-toast-notifications';
import { useTranslation } from 'react-i18next';

function InstitutionsView() {
  const [institutionsDataTable, setInstitutionsDataTable] = useState([]);
  const [institutions, setInstitutions] = useState({});

  const state = useSelector((reduxState) => ({
    institutionsData: reduxState.institutions.institutions,
    loading: reduxState.institutions.loading,
    error: reduxState.institutions.error,
  }));

  const { institutionsData, loading, error } = state;
  const { addToast } = useToasts();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (institutionsData && institutionsData.data) {
      const institutionsArray = institutionsData.data.institutions.docs;
      const dataT = institutionsArray.map((element) => {
        return [
          element.name,
          element.description,
          <Link to={`/editinstitutions/${element._id}`} className="mr-1 mb-1">
            <Button color="primary">{t('common.edit')}</Button>
          </Link>,
        ];
      });
      setInstitutionsDataTable(dataT);
      setInstitutions(institutionsData.data.institutions);
    }
  }, [institutionsData]);

  useEffect(() => {
    if (error) {
      addToast(error, {
        appearance: 'error',
        autoDismiss: true,
      });
      dispatch(cleanInstitutions());
    }
  }, [error]);

  const getPage = (page, term) => {
    if (page) {
      dispatch(getInstitutions(page, term));
    }
  };

  const columns = [
    t('common.institution'),
    t('common.description'),
    t('common.actions'),
  ];

  return (
    <>
      <DataTable
        link="/editinstitutions"
        columns={columns}
        getPage={getPage}
        loading={loading}
        fulldata={institutions}
        data={institutionsDataTable}
        title={t('institutions.institutions')}
        hasAdd
        textButton={t('institutions.addInstitution')}
      />
    </>
  );
}

export default InstitutionsView;
